export default __webpack_public_path__ + "static/media/SuccessRate.138dbf76.svg";